import {
    apiRequest,
    skpnsDetail
} from "../../../../../services/adapters/kepegawaian/skpnsService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", skpnsDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository